module.exports = require("assert");


/*****************
 ** WEBPACK FOOTER
 ** external "assert"
 ** module id = 18
 ** module chunks = 0
 **/